module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 15 10",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#youtube",
      toString: function () {
        return this.url;
      }
    }